import { TextField, Typography } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';
import { FieldError, UseFormGetValues, UseFormRegister } from 'react-hook-form';
import { Tooltip } from 'antd';
import { AiFillInfoCircle } from "react-icons/ai";

export interface ITypographyCustomProps {
  label: string,
  field: string,
  register: UseFormRegister<any>,
  getValues: UseFormGetValues<any>,
  fieldErrors?: FieldError | undefined,
  tooltip?: ReactNode,
}

export const TypographyCustom: React.FC<ITypographyCustomProps> = ({ label, field, register, getValues, fieldErrors, tooltip }) => {
  const [charCount, setCharCount] = useState(0);
  const maxCaracteres = 32000;
  const isLimit = charCount > maxCaracteres;

  useEffect(() => {
    const initialValue = getValues(field) || '';
    setCharCount(initialValue.length);
  }, [getValues, field]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const texto = event.target.value;
    setCharCount(texto.length);
  };

  return (
    <Typography>
      <div className="row mb-1 mt-2">
        <div className="col-12">
          <div>
            <label> {label} <Tooltip title={tooltip}><AiFillInfoCircle size={15} className="ms-1 info-color" style={{ fontSize: '24px', cursor: 'pointer' }} /></Tooltip></label>
            <TextField
              variant="outlined"
              className="form-control h-100"
              multiline
              rows={5}
              {...register(field)}
              defaultValue={getValues(field)}
              error={isLimit || !!fieldErrors}
              helperText={isLimit ? "Limite de caracteres acima do valor máximo! Por Favor Apague os caracteres que ultrapassaram o valor máximo" : fieldErrors?.message}
              onChange={handleInputChange}
            />
          </div>
          <p>{`${charCount}/${maxCaracteres}`}</p>
        </div>
      </div>
    </Typography>
  );
};